import async from 'async';
import utils from '@/utils';

const search = (options, commit, callback) => {
  utils.send({
    path: '/posts/search',
    options: {
      page: options.page,
      limit: options.limit,
      sortBy: options.sortBy,
      sortDesc: options.sortDesc,
      conditions: options.conditions,
    },
    callback(data) {
      commit('search', data);
      callback(null);
    },
  });
};

export default {
  searchList: ({ state, commit }, { page, limit, sortBy, sortDesc, conditions }) => {
    search({
      page: page,
      limit: limit,
      sortBy: sortBy,
      sortDesc: sortDesc,
      conditions: conditions,
    }, commit, (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  addItem: ({ state, commit }, { form, callback }) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/posts/add',
          options: {
            subject: form.subject,
            message: form.message,
            is_send: form.is_send,
          },
          callback(data) {
            utils.success('postsAdd');
            callback(data);
            next(null);
          },
        });
      },
      (next) => { search(state, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  updateItem: ({ state, commit }, { form, callback }) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/posts/update',
          params: [form.id],
          options: {
            subject: form.subject,
            message: form.message,
            is_send: form.is_send,
          },
          callback(data) {
            utils.success('postsUpdate');
            callback(data);
            next(null);
          },
        });
      },
      (next) => { search(state, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  deleteItem: ({ state, commit }, id) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/posts/delete',
          params: [id],
          callback(data) {
            utils.success('postsDelete');
            next(null);
          },
        });
      },
      (next) => { search(state, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  addQuote: ({ state, commit }, { id, refsMessage } ) => {
    let preMessage = state.form.message.substr(0, refsMessage.selectionStart);
    if (preMessage.length > 0 && preMessage.slice(-1) != '\n') {
      preMessage += '\n';
    }
    let postMessage = state.form.message.substr(refsMessage.selectionEnd);
    if (postMessage.length > 0 && postMessage[0] != '\n') {
      postMessage = '\n' + postMessage;
    }

    utils.send({
      path: '/posts/find',
      params: [id],
      callback(data) {
        let addMessage = '';
        addMessage += '[quote ' + data.item.number.toString() + ']\n';
        addMessage += data.item.message.trim();
        addMessage += '\n[/quote]';

        commit('replaceMessage', {
          pre: preMessage,
          add: addMessage,
          post: postMessage,
        });
      },
    });
  },

  /*
  addLink: ({ state, commit }, { id, refsMessage }) => {
    let preMessage = state.form.message.substr(0, refsMessage.selectionStart);
    if (preMessage.length > 0 && preMessage.slice(-1) != '\n') {
      preMessage += '\n';
    }
    let postMessage = state.form.message.substr(refsMessage.selectionEnd);
    if (postMessage.length > 0 && postMessage[0] != '\n') {
      postMessage = '\n' + postMessage;
    }

    utils.send({
      path: '/posts/find',
      params: [id],
      callback(data) {
        let addMessage = '[link ' + data.item.number.toString() + ']';

        commit('replaceMessage', {
          pre: preMessage,
          add: addMessage,
          post: postMessage,
        });
      },
    });
  },
  */

  changeForm: ({ state, commit }, id) => {
    utils.send({
      path: '/posts/find',
      params: [id],
      callback(data) {
        commit('loadForm', data.item);
      },
    });
  },

  clearForm: ({ state, commit }) => {
    commit('clearForm');
  },

  inputSubject: ({ state, commit }, text) => {
    commit('inputSubject', text);
  },

  inputMessage: ({ state, commit }, text) => {
    commit('inputMessage', text);
  },
};
